import { Component, OnInit } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { CommonService } from 'src/app/Services/common.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { DownloadService } from 'src/app/workflow/download/download.service';
import { FormularService } from 'src/app/Services/formular.service';
import { AuthentService } from 'src/app/Services/authent.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  resourceDefinition
  textDefinition
  FooterProvder
  isExpand: boolean = true;
  Version: string;

  constructor(
    private shareData: SharingDataService,
    public commonService: CommonService,
    private formularService: FormularService,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    private downloadService: DownloadService,
    private authentService: AuthentService
  ) { }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentLanguage.subscribe(data => {
      if(this.authentService.isLoggedIn()) this.getTexts(data)
    })
    this.getVersion();
    this.getFooterProvder();
  }

  getTexts(language){
    var urls = [`admin/V_GIP_TEXT_T?$filter=LANG eq '${language}'`,]

    this.formularService.getData(urls, res => {
      this.textDefinition = res[0];
    })
  }

  downloadDataProtection() {
    this.downloadService.downloadFileDSNB(this.commonService.getGipServicesUrl() + 'file/DataProtectionFile');
  }

  downloadTermsOfUse() {
    this.downloadService.downloadFileDSNB(this.commonService.getGipServicesUrl() + 'file/TermsOfUseFile');
  }

  downloadDataProtectionAndLegalNotice() {
    this.commonService.getData([`admin/V_GIP_DEFAULT_T`], (data) => {
      var url = "";
      data[0].forEach(element => {
          if (element.GIP_NAME == "INFO") { url = element.GIP_VALUE }
        });
        // window.location.href = url;
        window.open(url, 'blank');
    });
  }

  downloadHelp() {
    this.commonService.getData([`admin/V_GIP_DEFAULT_T`], (data) => {
      var url = "";
        data[0].forEach(element => {
          if (element.GIP_NAME == "INFO1") { url = element.GIP_VALUE }
        });
        // window.location.href = url;
        window.open(url, 'blank');
    });
  }

  downloadAboutUs() {
    this.commonService.getData([`admin/V_GIP_DEFAULT_T`], (data) => {
      var url = "";
        data[0].forEach(element => {
          if (element.GIP_NAME == "INFO2") { url = element.GIP_VALUE }
        });
        // window.location.href = url;
        window.open(url, 'blank');
    });
  }

  getVersion(){
    this.commonService.getPicklist([`portal/version`], (data) => {
      this.Version = data[0].version;
    });
  }

  getFooterProvder(){
    this.FooterProvder = this.translateResourceDefinition.transform("FooterProvder", this.resourceDefinition, "KEY_NAME", "SHORT_TEXT", "Common")
  }

}
